<template>
  <div>
    <div class="py-8">
      <p
        class="text-black font-semibold lg:text-2xl md:text-2xl text-2xl w-full"
      >
        Contacts
      </p>

      <div class="md:pt-6 lg:pt-6 pt-4">
        <div class="flex items-center mb-4">
          <feather-icon icon="PhoneIcon" class="" svgClasses="w-4 " />
          <p class="font-normal text-md ml-2">{{ userData.mobile }}</p>
        </div>

        <div class="flex items-center mb-4">
          <feather-icon icon="MailIcon" class="" svgClasses="w-4 " />
          <p class="font-normal text-md ml-2">{{ userData.email }}</p>
        </div>

        <div class="flex items-center mb-4">
          <feather-icon icon="MapIcon" class="" svgClasses="w-4 " />
          <p class="font-normal text-md ml-2">{{ userDetails.location }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    userDetails: Object
  },
  data() {
    return {};
  },

  computed: {
    ...mapState("auth", ["userData"])
  }
};
</script>

<style>
ul.bullet {
  list-style-type: square;
}
</style>
